import { ExecutionRequestStatus } from "@/lib/interfaces and Enums/ENUMExecutionRequestStatus";
import { IToggleCounterpartiesButton } from "./tradeSettingsInterfaces";

// Pure: derive the active counterparties for a trade from its execution
// requests, mirroring setPanelFromExistingTrade in CPList.tsx (Recalled /
// NotDealt excluded). The full Edit Panel sources its CP list from a
// /Counterparties/{esid} fetch (the full universe of CPs the trade can be sent
// to); the slide-in only ever needs the CPs already on the execution strategy,
// so reading the trade's own requests is both sufficient and the single source
// of truth — it keeps the slide-in from reading/writing the shared
// counterpartiesList slice the Edit Panel owns (LQC-1707).
// Exported for unit testing.
export function buildCounterpartiesListFromTrade(
  trade: any,
): IToggleCounterpartiesButton[] {
  const requests = trade?.executionRequestCounterParties;
  if (!Array.isArray(requests)) return [];
  const excluded = [
    ExecutionRequestStatus.Recalled,
    ExecutionRequestStatus.NotDealt,
  ];
  return requests
    .filter((cp: any) => !excluded.includes(cp.status))
    .map((cp: any) => ({
      message: undefined,
      name: cp.provider,
      code: cp.provider,
      activeDesks:
        cp.deskRestrictions && cp.deskRestrictions.length > 0
          ? cp.deskRestrictions
          : undefined,
      active: true,
    }));
}
